import AxiosInstance from 'src/shared/services/axios/interceptor';
import { Gift } from 'src/modules/gift/models/gift';
import { PagedResult } from 'src/shared/models/pagedResult';
import { setPagingParams } from 'src/shared/functions/createPagingParams';
import { GiftSearchFilter } from 'src/modules/gift/models/giftSearchFilter';

const controller = 'Deposit';

export const getGifts = (pageIndex, pageSize, sortCol, sortDir, searchFilter: GiftSearchFilter, startExport: boolean) => {
  let extraQuery = searchFilter.searchString ? `&filter=${searchFilter.searchString}` : '';
  extraQuery += searchFilter.isHandled !== null ? `&isHandled=${!!searchFilter.isHandled}` : '';
  extraQuery += searchFilter.fundraiserId ? `&fundraiser_id=${searchFilter.fundraiserId}` : '';
  extraQuery += searchFilter.dateFrom ? `&dateFrom=${searchFilter.dateFrom}` : '';
  extraQuery += searchFilter.dateTo ? `&dateTo=${searchFilter.dateTo}` : '';
  extraQuery += searchFilter.minAmount && searchFilter.minAmount > 0 ? `&minAmount=${searchFilter.minAmount}` : '';
  extraQuery += searchFilter.maxAmount && searchFilter.maxAmount > 0 ? `&maxAmount=${searchFilter.maxAmount}` : '';
  extraQuery += searchFilter.donorName ? `&donorName=${searchFilter.donorName}` : '';
  extraQuery += searchFilter.donorEmail ? `&donorEmail=${searchFilter.donorEmail}` : '';
  extraQuery += searchFilter.honoredName ? `&honoredName=${searchFilter.honoredName}` : '';
  extraQuery += startExport === true ? '&exportFormat=csv' : '';

  const endpoint = `${controller}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<Gift>>(endpoint);
};

export const getGiftById = (id) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<Gift>(endpoint);
};

export const deleteGift = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.delete(endpoint);
};
